// components/ChangeView.jsx
import React, { useState } from 'react';
import './ChangeView.css';

const ChangeView = ({ onViewChange, currentView }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(currentView || 'all');

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const handleApply = () => {
    onViewChange(selectedView);
    setIsOpen(false);
  };

  return (
    <div className="change-view-container">
      <button
        className="btn btn__white_g change-view-btn"
        onClick={toggleDropdown}
      >
        Change the View {isOpen ? '▲' : '▼'}
      </button>
      {isOpen && (
        <div className="change-view-dropdown">
          <div className="view-option">
            <input
              type="radio"
              id="view-left"
              name="view"
              value="left"
              checked={selectedView === 'left'}
              onChange={() => handleViewChange('left')}
            />
            <label htmlFor="view-left">Show Left</label>
          </div>
          <div className="view-option">
            <input
              type="radio"
              id="view-left-order"
              name="view"
              value="left-order"
              checked={selectedView === 'left-order'}
              onChange={() => handleViewChange('left-order')}
            />
            <label htmlFor="view-left-order">Show Left + Order</label>
          </div>
          <div className="view-option">
            <input
              type="radio"
              id="view-all"
              name="view"
              value="all"
              checked={selectedView === 'all'}
              onChange={() => handleViewChange('all')}
            />
            <label htmlFor="view-all">Show All Columns</label>
          </div>
          <button
            className="btn btn__green apply-btn"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default ChangeView;